import type { ChatMessageContent } from "schemas/generated/chatMessage";

import React from "react";

import { VideoThumbnail } from "@v2/features/chat/components/chat-elements/VideoThumbnail";

type VideoMessageContent = Extract<
  ChatMessageContent[number],
  { type: "video" }
>;

interface VideoMessageItemProps {
  item: VideoMessageContent;
}

export const VideoMessageItem = ({ item }: VideoMessageItemProps) => {
  if (item.isHidden) {
    return null;
  }

  return (
    <VideoThumbnail
      src={item.video}
      size="medium"
      className="rounded-lg border-border bg-white"
    />
  );
};
